import { render, staticRenderFns } from "./VehicleViolationReportForm.vue?vue&type=template&id=20a3700c&"
import script from "./VehicleViolationReportForm.vue?vue&type=script&lang=js&"
export * from "./VehicleViolationReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports